// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CommissionDefaultAsset } from "../../../Utils/Enums/Constants.js";

/// Cодержит набор комиссий применительно к инструменту/группе

export let RevenueCommissionEntryItem = function ()
{
    this.Type = null;
    this.Name = null;
    this.ShortCommissionInfo = null;

    this.InstrumentTypeId = null;
    this.InstrumentId = null;

    this.AssetID = CommissionDefaultAsset.INSTRUMENT_QUOTING_CCY;
    this.Currency = null;

    this.UseInVAT = null;

    this.CommissionItems = new Array();     // new List<RevenueCommissionItem>();
}

Object.defineProperty(RevenueCommissionEntryItem.prototype, "TypeId",
    {
        get: function () { return this.InstrumentTypeId; }
    });

RevenueCommissionEntryItem.prototype.GetCommission = function (param)
{
    let value = 0;

    this.CommissionItems.forEach(function (revenueItem) { value += revenueItem.GetCommission(param) })

    return value;
}

RevenueCommissionEntryItem.prototype.ContainsCommission = function (type)
{
    let items = this.CommissionItems
    if (!items || !items.length) return false

    for (let i = 0; i < items.length; i++)
        if (items[i].Type == type)
            return true

    return false
}

RevenueCommissionEntryItem.prototype.GetLotsListForType = function (outLotsArray, commissionType, operationType)
{
    let items = this.CommissionItems
    if (!items || !items.length) return false

    for (let i = 0; i < items.length; i++)
        items[i].GetLotsListForType(outLotsArray, commissionType, operationType)
}

RevenueCommissionEntryItem.prototype.IsSingleField = function (type)
{
    for (let i = 0; i < this.CommissionItems.length; i++)
    {
        let item = this.CommissionItems[i]
        if (item.Type == type)
            return item.IsSingleField()
    }

    return false
}

RevenueCommissionEntryItem.prototype.ShowOpenClose = function (type)
{
    for (let i = 0; i < this.CommissionItems.length; i++)
    {
        let item = this.CommissionItems[i]
        if (item.Type == type)
            return item.IsShowOpenClose()
    }

    return false
}

RevenueCommissionEntryItem.prototype.ContainsShort = function (type)
{
    for (let i = 0; i < this.CommissionItems.length; i++)
    {
        let item = this.CommissionItems[i]
        if (item.Type == type)
            return item.ContainsShort()
    }

    return false
}